import { Alert } from "react-bootstrap";

const PromoCodeMessage = ({ promoCodeMessage }) => {
    if (promoCodeMessage) {
        return <Alert variant="warning" className="text-center">
            <strong>{promoCodeMessage}</strong>
            </Alert>;
    }
    return null;
    
};
export default PromoCodeMessage;
